import { MainWrapper } from "./MainWrapper";
import style from "../../assets/scss/sub/simpleTest.module.scss";
import downIcon from "../../assets/images/drawer_menu/down_icon.svg";
import upIcon from "../../assets/images/drawer_menu/up_icon.svg";
import checked from "../../assets/images/drawer_menu/checkbox_icon_checked.svg";
import checkedMobile from "../../assets/images/drawer_menu/checkbox_icon_checked_mobile.svg";
import unchecked from "../../assets/images/drawer_menu/checkbox_icon.svg";
import uncheckedMobile from "../../assets/images/drawer_menu/checkbox_icon_mobile.svg";
import bannerImg from "../../assets/images/drawer_menu/simple_test_banner_icon.svg";
import bannerImgMobile from "../../assets/images/drawer_menu/simple_test_banner_icon_mobile.svg";
import inspectionImg from "../../assets/images/drawer_menu/inspection_ing.svg";
import { useModal, useAuth, useUserAgent, useAppDispatch } from "../../hooks/hooks";
import { useUserInfoGetter } from "../common/hooks/useUserInfoGetter";
import { useState, useEffect } from "react";
import { createSimpleUserAsync } from "../../store/simpletest/simpleTest";

export function SimpleTest() {
  const [isDivHidden, setIsDivHidden] = useState(true);
  const [isAgree, setIsAgree] = useState(false);
  const [name, setName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [nameError, setNameError] = useState("");
  const [birthDateError, setBirthDateError] = useState("");
  const [isStarted, setIsStarted] = useState(false);
  const dispatch = useAppDispatch();

  const { isLoggedIn } = useAuth();
  const { openAlertModal } = useModal();
  const { isDesktop } = useUserAgent();
  const { getUserInfo, user } = useUserInfoGetter();
  const { openConfirmModal } = useModal();

  const handleDivClick = () => {
    setIsDivHidden(!isDivHidden);
  };

  const handleIsAgree = () => {
    setIsAgree(!isAgree);
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (/^[가-힣]*$/.test(value)) {
      setNameError("");
    } else {
      setNameError("이름은 한글로 입력해 주세요.");
    }
  };

  function formatDate(dateString) {
    // 연도, 월, 일 추출
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    // 형식에 맞게 반환
    return `${year}-${month}-${day}`;
  }

  const handleBirthDateChange = (e) => {
    const value = e.target.value;
    setBirthDate(value);

    // 정규식을 통해 값이 8자리 숫자인지 확인
    if (/^\d{8}$/.test(value)) {
      if (isValidDate(value)) {
        setBirthDateError("");
      } else {
        setBirthDateError("유효한 생년월일이 아닙니다.");
      }
    } else {
      setBirthDateError("생년월일은 8자리 숫자로 입력해 주세요.");
    }
  };

  // 유효한 날짜인지 확인하는 함수
  const isValidDate = (dateString) => {
    // 연도, 월, 일 추출
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6));
    const day = parseInt(dateString.substring(6, 8));

    // 월 범위 확인
    if (month < 1 || month > 12) {
      return false;
    }

    // 날짜 유효성 확인 (월별 일 수 체크)
    const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day < 1 || day > daysInMonth[month - 1]) {
      return false;
    }

    // 생년월일이 미래인지 확인
    const today = new Date();
    const birthDate = new Date(year, month - 1, day);
    if (birthDate > today) {
      return false;
    }

    return true;
  };

  // 윤년 확인 함수
  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  const validateInputs = () => {
    let isValid = true;

    if (!isAgree) {
      openAlertModal({
        title: "안내",
        desc: "개인정보 수집 및 이용 약관에 동의해 주세요.",
      });
      isValid = false;
    }

    if (!isLoggedIn) {
      if (name.trim() === "") {
        setNameError("이름을 입력해 주세요.");
        isValid = false;
      } else if (!/^[가-힣]*$/.test(name)) {
        setNameError("이름은 한글로 입력해 주세요.");
        isValid = false;
      }

      if (birthDate.trim() === "") {
        setBirthDateError("생년월일을 입력해 주세요.");
        isValid = false;
      } else if (!/^\d{8}$/.test(birthDate) || !isValidDate(birthDate)) {
        setBirthDateError("유효한 생년월일이 아닙니다.");
        isValid = false;
      }
    }

    return isValid;
  };

  const onClickStart = async () => {
    if (isLoggedIn) {
      await dispatch(
        createSimpleUserAsync({
          name: user?.name,
          birthday: user?.birthday,
        })
      )
        .then((response) => {
          const url = `https://dcas-simple.feel-good.io?idx=${response.payload.idx}`;
          openFullScreen(url);
        })
        .catch((error) => {
          console.error("API call failed:", error);
        });
    } else {
      if (validateInputs()) {
        await dispatch(
          createSimpleUserAsync({
            name,
            birthday: formatDate(birthDate),
          })
        )
          .then((response) => {
            const url = `https://dcas-simple.feel-good.io?idx=${response.payload.idx}`;
            openFullScreen(url);
          })
          .catch((error) => {
            console.error("API call failed:", error);
          });
      } else {
        console.log("validation check failed!");
      }
    }
  };

  useEffect(() => {
    // 검사 시작 전 상태로 변경
    setIsStarted(false);
    if (isLoggedIn) {
      if (!user) {
        getUserInfo().then();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, user]);

  useEffect(() => {
    if (isStarted) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isStarted]);

  const openFullScreen = (url) => {
    // 아이패드 인식을 위한 로직 추가

    if (!isDesktop || (window.navigator.userAgent.indexOf("Safari") > 0 && navigator.maxTouchPoints > 0)) {
      openConfirmModal(
        {
          title: "모바일 간이 검사 안내",
          desc: "D-CAS 간이 검사 테스트는 모바일에서 가로모드만 지원 합니다. \n가로모드 전환 후 확인을 눌러주세요.",
        },
        () => {
          // 모바일에서는 현재 창에서 URL 열기
          window.location.href = url;
          // 검사 시작 상태로 변경
          setIsStarted(true);
        }
      );
    } else {
      // 데스크탑에서는 새 창
      window.open(url, "_blank");
      // 검사 시작 상태로 변경
      setIsStarted(true);
    }
  };

  return (
    <>
      <MainWrapper showFooter={true} mainClassName={style.simpleWrapper}>
        <div className={style.simpleBackground}>
          <div className={style.simpleContainer} style={{ display: !isStarted ? "block" : "none" }}>
            <div className={style.testTitle}>D-CAS 간이 검사 테스트</div>
            {/* 로그인된 페이지 배너 이미지 */}
            {isLoggedIn &&
              (isDesktop ? (
                <img src={bannerImg} className={style.simpleBanner} alt={"bannerImg"} />
              ) : (
                <img src={bannerImgMobile} className={style.simpleBanner} alt={"bannerImgMobile"} />
              ))}
            {isLoggedIn && (
              <div className={style.infoContainer}>
                <p className={style.birthText}>{user?.birthday ? user?.birthday : "2000년 00월 00일생"}</p>
                <p className={style.nameContainer}>
                  <span className={style.nameText}>{user?.name ? user?.name : "홍길동"}</span>
                  <span className={style.nameSubText}>님</span>
                </p>
              </div>
            )}
            <div className={style.testSubTitle}>D-CAS 간이 검사 안내</div>
            <div className={style.testDescription}>
              * 간이 검사 테스트는 무료로 제공됩니다. <br />
              * 간이 검사 테스트는 PC 또는 스마트폰으로 진행 가능하며, 검사 시간은 약 10~15분 소요됩니다(스마트폰으로
              진행 시 가로모드로 진행해 주세요).
              <br />
              * 간이 검사 테스트는 D-CAS 정식 검사와 유형은 같지만 간이 검사 전용의 별도 문항으로 검사가 진행되며,
              흥미유발을 위한 게임 연출 요소는 포함되어 있지 않습니다.
              <br />
              * 정확한 검사를 위해 조용한 환경에서, 기기 볼륨을 높인 상태로 진행해 주세요.
              <br />* 간이 테스트 종료 후 D-CAS 간이 검사 전용 약식 검사 결과지를 즉시 확인할 수 있습니다.
            </div>
            {!isLoggedIn && (
              <div className={style.inputSection}>
                <p className={style.inputTitle}>이름</p>
                <input
                  className={`${style.inputTextArea} ${name.length > 0 ? style.checked : ""}`}
                  onChange={handleNameChange}
                  placeholder="이름을 입력해주세요."
                ></input>
                {nameError && <p className={style.errorMessage}>{nameError}</p>}
              </div>
            )}
            {!isLoggedIn && (
              <div className={style.inputSection}>
                <p className={style.inputTitle}>생년월일</p>
                <input
                  className={`${style.inputTextArea} ${birthDate.length > 0 ? style.checked : ""}`}
                  onChange={handleBirthDateChange}
                  placeholder="8자리 생년월일을 입력해 주세요."
                ></input>
                {birthDateError && <p className={style.errorMessage}>{birthDateError}</p>}
              </div>
            )}
            <div className={style.inputSection}>
              <p className={style.inputTitle}>약관 동의</p>
              <button
                className={`${style.privacyTextArea} ${isAgree ? style.checked : ""}`}
                onClick={handleIsAgree}
                style={{ marginBottom: "14px" }}
              >
                <img
                  className={style.isAgreeBtn}
                  src={isAgree ? (isDesktop ? checked : checkedMobile) : isDesktop ? unchecked : uncheckedMobile}
                  alt="downAndUpBtn"
                ></img>
                개인정보 수집 및 이용 동의
              </button>
              <p className={style.privacyText}>
                * 이름과 생년월일은 원활한 서비스 이용을 위해 수집합니다.
                <br />
                * 수집된 개인정보는 제3자(타인, 타기업 혹은 기관 등)에게 회원의 사전 동의 없이 제공하지 않습니다.
                <br />* 이용 약관은 아래의 내용 자세히보기를 참고해 주세요.
              </p>
            </div>
            <div className={style.moreContainer}>
              <p className={style.moreText} onClick={handleDivClick} style={{ cursor: "pointer" }}>
                내용 자세히보기
                <img src={isDivHidden ? downIcon : upIcon} alt="downAndUpBtn" style={{ marginLeft: "4px" }}></img>
              </p>
              <div className={style.dashedLine} style={{ display: isDivHidden ? "none" : "block" }}></div>
              <p style={{ marginTop: "8px", display: isDivHidden ? "none" : "block" }}>
                <span className={style.moreTextTitle}>1. 서비스 이용 </span>
                <br />
                <span className={style.moreTextDesc}>
                  1) “D-CAS 간이 검사 테스트”는 연중무휴 1일 24시간 서비스 운영을 원칙으로 합니다. 단, 회사는 시스템
                  정기점검, 유지보수 등을 위해 회사가 정한 날이나 시간에 서비스를 일시 중단할 수 있습니다.
                  <br />
                  2) 회사는 다음의 경우 사전공지나 예고 없이 서비스를 일시적 혹은 영구적으로 중단할 수 있습니다. <br />
                  ① 긴급한 시스템 점검, 고장, 통신의 두절 등의 사유가 발생한 경우 <br />
                  ② 국가비상사태, 장전, 천재지변 등의 불가항력인 사유가 있는 경우
                  <br />
                  ③ 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우 <br />
                  ④ 전기통신사업법에 규정된 전기통신사업자가 전기통신서비스를 중지했을 경우 <br />
                  ⑤ 네트워크 상의 위험성에 기초한 타인의 서비스 제공 음해 행위가 있을 경우
                  <br />
                  <br />
                </span>
                <span className={style.moreTextTitle}>2. 서비스 이용상 책임</span>
                <br />
                <span className={style.moreTextDesc}>
                  서비스 이용자가 회사가 제공하는 서비스를 통해 취득한 정보를 이용하여 회사를 매개로 하지 않고 직접
                  거래를 함으로써 회사에 손해가 발생할 경우, 회사는 회원에게 손해에 대한 민, 형사상 책임을 물을 수
                  있습니다.
                </span>
                <br />
                <br />
                <span className={style.moreTextTitle}>3.저작권의 귀속 및 이용 제한</span>
                <br />
                <span className={style.moreTextDesc}>
                  1) 서비스를 운영함에 따라 회사가 서비스 내에서 작성한 저작물에 대한 저작권 기타 지적 재산권은 회사에
                  귀속합니다.
                  <br />
                  2) 서비스 이용자는 서비스를 이용함으로써 얻은 정보 중 회사에 지적재산권이 귀속된 정보를 회사의 사전
                  승낙 없이 복제, 배포, 방송 기타 방법에 의하여 영리목적으로 이용해서는 안됩니다.
                </span>
                <br /> <br />
                <span className={style.moreTextTitle}>4. 개인정보의 제3자 제공 및 개인정보 처리 업무의 위탁 </span>
                <br />
                <span className={style.moreTextDesc}>
                  회사는 원칙적으로 회원의 개인정보를 개인정보 처리 방침에서 명시한 범위 내에서 처리 하며, 제3자(타인,
                  타기업 혹은 기관 등)에게 회원의 사전 동의 없이 본래의 범위를 초과하여 처리하거나, 제3자에게 제공하지
                  않습니다. 다만, 다음의 경우에는 개인정보를 목적 외의 용도로 이용하거나, 이를 제3자에게 제공할 수
                  있습니다. <br />
                  1) 서비스 이용자가 사전에 동의한 경우 <br />
                  2) 통계 및 학술연구, 시장조사 등을 위하여 필요한 경우로, 특정 개인을 식별할 수 없는 형태로 개인정보를
                  제공하는 경우
                  <br />
                  3) 다른 법률에 특별한 규정이 있는 경우 <br />
                  4) 회사가 법령상 의무를 준수하기 위하며 불가피하게 수집한 개인정보를 그 수집 목적 범위 내에서 제공하는
                  경우
                </span>
              </p>
              <div
                className={style.dashedLine}
                style={{ marginTop: "8px", display: isDivHidden ? "none" : "block" }}
              ></div>
            </div>

            <button className={style.startBtn} style={{ marginTop: "70px" }} onClick={onClickStart}>
              시작하기
            </button>
          </div>
          <div className={style.inspectionProgress} style={{ display: isStarted ? "block" : "none" }}>
            <img src={inspectionImg} className={style.inspectionImg} alt={inspectionImg}/>
            <h2 className={style.progressText}>현재 검사가 진행중입니다.</h2>
            <p className={style.progressSubText}>끝까지 검사를 진행하신 후 결과를 확인해 보세요!</p>
          </div>
        </div>
      </MainWrapper>
    </>
  );
}
